'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PrimaryLanguage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrimaryLanguage(_ref) {
  var bib = _ref.bib,
      separator = _ref.separator,
      hiddenLanguages = _ref.hiddenLanguages;

  var primaryLanguage = bib.getIn(['briefInfo', 'primaryLanguage']);
  if (primaryLanguage && !hiddenLanguages.includes(primaryLanguage)) {
    return _react2.default.createElement(
      'span',
      { className: 'cp-primary-language' },
      separator,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'LANGUAGE.' + primaryLanguage })
    );
  }

  return null;
}

PrimaryLanguage.defaultProps = {
  hiddenLanguages: ['eng', 'und', 'zxx'],
  separator: ' | '
};

PrimaryLanguage.propTypes = {
  bib: _reactImmutableProptypes2.default.mapContains({
    primaryLanguage: _react.PropTypes.string
  }),
  hiddenLanguages: _react.PropTypes.arrayOf(_react.PropTypes.string),
  separator: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-primary-language/lib/components/PrimaryLanguage.component.js
// module id = 1499
// module chunks = 1